<template>
  <div class="pictureControl">
    <a-spin :spinning="spin">
      <div class="top">
        <!-- 第二部分 -->
        <div class="selectTop">
          <div style="display: flex">
            <span class="topTitle">素材名称：</span>
            <a-input
              v-model="imgName"
              placeholder="请输入"
              style="width: 200px; margin-left: 5px"
            />
          </div>
          <div>
            <a-button
              type="primary"
              style="margin-left: 15px; font-size: 14px"
              @click="search"
              >查询</a-button
            >
            <a-button @click="clear" style="margin-left: 15px">重置</a-button>
          </div>
        </div>
      </div>
      <!-- 图 -->
      <div style="width: 100%; height: 10px; background: #edeff2"></div>
      <div class="bottom">
        <!-- 顶部 -->
        <div style="border: 1px solid #edeff2; margin-bottom: 15px">
          <div class="moTitle">
            <div class="topTitle font">收藏列表</div>
          </div>
        </div>

        <!-- 显示 -->
        <div style="width: 98%; margin: auto; position: relative">
          <a-row :gutter="16" type="flex" justify="start" align="bottom">
            <!-- 空数据 -->
            <div
              v-if="picture.length == 0"
              style="
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
              "
            >
              <NullDataPrompt message="暂无图片"></NullDataPrompt>
            </div>
            <a-col
              v-else
              :span="innerWidths > 0 && innerWidths < 1920 ? 5 : 4"
              style="margin-bottom: 2%"
              v-for="(item, index) in picture"
              :key="item.id"
            >
              <div
                :style="{
                  width:
                    innerWidths > 0 && innerWidths < 1920 ? '100%' : '100%', }"
                class="item"
                @mouseenter="showYuan(index)"
                @mouseleave="unshow"
              >
                <!-- 图片 -->
                <div style="width: 100%; height: 75%;background-color: rgba(0,0,0,.85);">
                  <img
                    :src="item.url"
                    style="
                      width: 100%;
                      height: 100%;
                      border-bottom: 1px solid #f5f5f5;
                    "
                  />
                </div>
                <!-- 名字 -->
                <!-- <div v-show="index === selectIndex ? true : false">
                  <a-dropdown>
                    <a class="yuan">
                      <a-icon
                        type="ellipsis"
                        style="font-size: 26px; color: rgb(167, 160, 160)"
                      />
                    </a>
                    <a-menu
                      style="margin-left: -50px; margin-top: -3px"
                      slot="overlay"
                      @mouseenter="showYuan(index)"
                      z-index="999"
                    >
                      <a-menu-item @click="changeName(index, item)">
                        重命名
                      </a-menu-item>
                      <a-menu-item @click="changeCategory(item)"
                        >移动分组</a-menu-item
                      >
                      <a-menu-item @click="del(item)"> -->
                <!-- 删除 -->
                <!-- <a-popconfirm
                    title="确认删除图片?"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="delPicture(item)"
                    @cancel="cancel"
                    style="z-index: 999999; margin-right: 30px"
                  >
                    <span style="display: inline-block; width: 120%">删除</span>
                  </a-popconfirm> -->
                <!-- </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div> -->
                <div
                  class="dropdown"
                  v-show="index === selectIndex ? true : false"
                >
                  <a class="dropdown-button">
                    <a-icon
                      type="ellipsis"
                      style="font-size: 26px; color: rgb(167, 160, 160)"
                    />
                  </a>
                  <div class="dropdown-menu">
                    <a @click="changeName(index, item)"> 重命名</a>
                    <!--                  <a @click="changeCategory(item)">移动分组</a>-->
                    <a @click="del(item)">删除</a>
                  </div>
                </div>

                <!-- 名字 -->
                <div
                  style="
                    width: 100%;
                    height: 10%;
                    font-size: 19px;
                    position: absolute;
                    bottom: 37px;
                  "
                >
                  <div
                    v-if="index == inputshow ? false : true"
                    style="
                      width: 98%;
                      margin-top: 5px;
                      margin-left: 7px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      font-size: 16px;
                      font-weight: 600;
                      color: black;
                    "
                  >
                    {{ item.name }}
                  </div>
                  <div
                    v-if="index == inputshow ? true : false"
                    style="width: 100%; height: 50%"
                  >
                    <a-input
                      id="addLabel"
                      v-if="index == inputshow ? true : false"
                      v-model="pictureName"
                      :placeholder="item.name"
                      @pressEnter="changeimgName(item)"
                      @blur="change"
                    >
                    </a-input>
                  </div>
                </div>
                <!-- 时间 -->
                <div
                  style="
                    width: 100%;
                    height: 10%;
                    position: absolute;
                    bottom: 0;
                  "
                >
                  <p :style="{ color: variables.greyFont, marginLeft: '7px' }">
                    {{ item.createdTime }}
                  </p>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>

      <!-- 分页 -->
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <a-pagination
          :current="curPage"
          :total="total"
          :pageSize="pageSize"
          show-quick-jumper
          @change="PageNOchange"
        />
      </div>

      <!-- 移动分组弹窗 -->
      <a-modal
        :visible="visible"
        title="选择分类"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <a-radio-group
          button-style="solid"
          :default-value="categoryId"
          :key="categoryId"
        >
          <a-radio-button
            :value="item.id"
            v-for="item in topData"
            :key="item.id"
            @click="handle(item)"
          >
            {{ item.title }}
          </a-radio-button>
        </a-radio-group>
        <!-- <a-button
        @click="handle(item)"
        v-for="item in topData"
        :key="item.id"
        style="margin-left: 20px"
        >{{ item.title }}</a-button
      > -->
      </a-modal>
      <!-- 删除 -->
      <a-modal
        :visible="delVisible"
        @ok="deleteOk"
        @cancel="delCancel"
        :width="300"
        :height="20"
      >
        <p style="font-size: 18px">确认删除图片？</p>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import variables from "@/assets/base.scss";
import {
  getManagement,
  getPicture,
  changePicture,
  delPicture,
  InsertImg,
} from "../../../service/columnmanageapi";
import { postImgList } from "@/service/document_api";
import NullDataPrompt from "../../../components/NullDataPrompt.vue";
export default {
  name: "pictureControl",
  components: { NullDataPrompt },
  data() {
    return {
      spin: false,
      variables,
      innerWidths: null,
      year: [],
      topData: [],
      picture: [],
      typeid: "",
      imgName: "",
      pictureName: "",
      startTime: "",
      endTime: "",
      curPage: 1, //当前页
      total: 0, //总数
      pageSize: 8,
      showIndex: -1,
      selectIndex: -1, //圆孔显示
      boxShow: -1, //操作框显示
      inputshow: -1, //输入框显示
      visible: false, //分组弹窗显示
      category: {},
      iconList: [],
      categoryId: "",
      delVisible: false,
      delete: {},
    };
  },
  created() {
    this.innerWidths = window.innerWidth; //屏幕宽度
    this.pageSize = this.innerWidths > 0 && this.innerWidths < 1920 ? 10 : 12;
    this.load();
  },
  methods: {
    // 头部导航分类
    load() {
      this.spin = true;
      //  获取图片
      getPicture({
        // columnId: this.typeid,
        // startTime: this.startTime,
        // endTime: this.endTime,
        name: this.imgName,
        isMyCollection: 1,
        curPage: this.curPage,
        pageSize: this.pageSize,
      }).then((res) => {
        console.log(res);
        this.picture = res.data;
        this.total = res.count;
        this.spin = false;
      });
    },

    // 点击类别
    onChange(e) {
      this.curPage = 1;
      this.typeid = e.target.value;
      if (this.typeid == 0) {
        this.typeid = "";
      }
      this.load();
    },
    // 点击时间选择框
    timeChange(date, dateString) {
      this.year = dateString;
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    // 点击查询
    search() {
      this.curPage = 1;
      this.load();
    },
    change() {
      this.inputshow = -1;
      this.load();
      this.pictureName = "";
    },
    // 点击重置
    clear() {
      this.year = [];
      this.imgName = "";
      this.startTime = "";
      this.endTime = "";
      this.load();
    },
    // 改变页码
    PageNOchange(curPage) {
      this.curPage = curPage;
      this.load();
    },
    // 鼠标经过
    showYuan(index) {
      this.selectIndex = index;
      this.showIndex = index;
      // this.boxShow = -1;
    },
    //鼠标移开
    unshow() {
      this.selectIndex = -1;
    },
    changeboxShow(index) {
      this.boxShow = index;
    },
    // 重命名
    changeName(index, item) {
      this.pictureName = item.name;
      this.inputshow = index;
      // this.$refs["addLabel"].focus();
      this.$nextTick(function () {
        document.getElementById("addLabel").focus();
      });
    },

    // 输入框确定回调
    changeimgName(item) {
      changePicture({
        id: item.id,
        name: this.pictureName,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.inputshow = -1;
          this.load();
          this.pictureName = "";
        }
      });
    },

    // 打开删除
    del(item) {
      this.delete = item;
      console.log(item);
      this.delVisible = true;
    },
    // 删除确定回调
    deleteOk() {
      delPicture(this.delete.id).then((res) => {
        if (res.code == 0) {
          this.$message.success("删除成功");
          this.delVisible = false;
          this.load();
        } else {
          this.$message.warning("删除失败");
        }
      });
    },
    // 删除取消回调
    delCancel() {
      this.$message.warning("取消删除");
      this.delVisible = false;
      this.load();
    },
    // 点击移动分组回调 打开弹窗
    changeCategory(item) {
      this.visible = true;
      this.category.id = item.id;
      this.categoryId = item.columnId;
      console.log("111", this.category.columnId);
    },
    // 弹出框按钮回调
    handle(item) {
      this.category.columnId = item.id;
    },
    // 弹出框确定
    handleOk() {
      console.log(this.category.columnId);
      changePicture({
        id: this.category.id,
        columnId: this.category.columnId,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.visible = false;
          this.categoryId = "";

          this.load();
        } else {
          this.$message.warning("修改失败");
          this.visible = false;
          this.categoryId = "";
          this.load();
        }
      });
    },
    // 弹出框取消
    handleCancel() {
      this.categoryId = "";
      this.visible = false;
      this.load();
    },
    // 批量上传图片
    async up_iconList(name) {
      this.spin = true;
      const fileList = document.getElementById("files").files;
      console.log("图片", fileList);
      let formData = new FormData();
      for (const file of fileList) {
        let picture = {};
        picture.name = file.name;
        formData.append("file", file);
        const image = await postImgList(formData);
        if (image.code === 0) {
          for (const images of image.data.url) {
            picture.url = images;
          }
          this.iconList.push({
            url: picture.url,
            name: picture.name,
            columnId: this.typeid,
          });
        }
        InsertImg(this.iconList).then((res) => {
          if (res.code == 0) {
            this.spin = false;
            this.load();
            this.iconList = [];
            this.$message.success("上传成功");
          } else {
            this.spin = false;
            this.load();
            this.iconList = [];
            this.$message.warning("上传失败");
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ant-col-5 {
  width: 20%;
}
.ant-col-4 {
  width: 16.66666%;
}

.pictureControl {
  width: 100%;
  min-height: 100%;
  border: 10px solid #edeff2;
}
.top {
  width: 100%;
  height: 50px;
  .classTitle {
    width: 100%;
    height: 50%;
    border-bottom: 1px solid #edeff2;
    .title {
      margin-left: 1%;
      display: inline-block;
      padding-top: 20px;
      color: $topTitleColor;
    }
    .content {
      color: $topNameColor;
      margin-left: 5px;
    }
  }
  .selectTop {
    width: 98%;
    height: 50%;
    margin: auto;
    display: flex;
    //justify-content: space-between;
    line-height: 30px;
    margin-top: 15px;
  }
}
.topTitle {
  color: $topTitleColor;
}
.ant-radio-button-wrapper {
  border-radius: 5px;
  border: none;
  &::before {
    display: none; // 隐藏分界线
  }
}
::v-deep .ant-radio-button-wrapper::before {
  display: none;
}
.bottom {
  width: 100%;
  min-height: 480px;
}
.item {
  position: relative;
  width: 100%;
  height: 230px;
  // display: inline-block;
  border: 1.3px solid #edeff2;
  // margin-left: 1%;
  // margin-right: 1%;
  // margin-bottom: 2%;
  .yuan {
    position: absolute;
    top: 0%;
    right: 1.5%;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background: white;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  .box {
    position: absolute;
    // display: block;
    top: 0px;
    right: 0px;
    width: 70px;
    // height: 40%;
    // background: #fff;
    // z-index: 2;
    // border-radius: 5px;
    // span {
    //   display: inline-block;
    //   background: #fff;
    //   width: 100%;
    //   height: 33.4%;
    //   cursor: pointer;
    // }
  }
}
.moTitle {
  display: flex;
  justify-content: space-between;
  width: 98%;
  margin: auto;
  height: 50px;
  line-height: 50px;
  .font {
    font-weight: 600;
    color: $topNameColor;
  }
}

.file {
  position: relative;
  display: inline-block;
  background: #1890ff;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: white;
  font-size: 15px;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
}
.file input {
  position: absolute;
  font-size: 110px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: #1890ff;
  color: white;
  text-decoration: none;
}
/* 按钮样式 */
.dropdown-button {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background: white;
  text-align: center;
  line-height: 40px;
}

/* 下拉菜单 */
.dropdown-menu {
  /* 默认不显示 */
  display: none;
  /* 设置宽度 */
  width: 80px;
  /* 设置边框 */
  // border: 2px solid #e5f1fb;
  margin-top: 35px;
  border-radius: 5px;
  background-color: white;
}
/* 鼠标悬停时，显示菜单区域 */
.dropdown:hover .dropdown-menu {
  display: block;
}
/* 链接样式 */
.dropdown-menu a {
  /* 换行 */
  display: block;
  /* 黑色字体 */
  color: $topNameColor;
  /* 增大间距 */
  padding: 8px 12px;
  /* 去掉下划线 */
  text-decoration: none;
}

/* 整个下拉菜单 */
.dropdown {
  display: inline-block;
  position: absolute;
  top: 2px;
  right: 8px;
}
</style>
